module.exports = __webpack_public_path__ + "img/smart-climate-sensor-md.a6c063fc.svg";